import React from "react";
import { experiences, earlierRoles } from "../../data/experience";
import { nodeId } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import CaseStamp from "../../components/investigation/CaseStamp";
import { detailFromExperience, detailFromPriorRecord } from "../../utils/evidenceDetail";

export const ExperienceSection = () => (
  <div className="experience-cluster">
    <div className="evidence-group">
      <p className="evidence-group-label">
        Software engineering <span>· newest first</span>
      </p>
      <ol className="timeline-row">
        {experiences.map((job, index) => (
          <li key={job.id}>
            <EvidenceCard
              variant="paper"
              pin={job.current ? "red" : index % 2 ? "brass" : "black"}
              rotate={index % 2 === 0 ? -0.7 : 0.9}
              className="timeline-card"
              nodeId={nodeId.job(job.id)}
              detail={detailFromExperience(job)}
            >
              <div className="timeline-head">
                <span className="timeline-year">{job.year}</span>
                {job.current ? (
                  <CaseStamp tone="red" rotate={-5} className="tiny-stamp">
                    Current
                  </CaseStamp>
                ) : null}
              </div>
              <EvidenceImage
                src={job.logo}
                alt={job.logo ? `${job.company} logo` : ""}
                variant="logo"
                pin={false}
                placeholderLabel="INDEPENDENT"
              />
              <h3>{job.title}</h3>
              <p className="timeline-company">
                {job.link ? (
                  <a href={job.link} target="_blank" rel="noreferrer">
                    {job.company}
                  </a>
                ) : (
                  job.company
                )}
              </p>
              <p className="timeline-dates">{job.duration}</p>
              <ul className="timeline-bullets">
                {job.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
              <p className="timeline-stack">{job.stack}</p>
            </EvidenceCard>
          </li>
        ))}
        <li>
          <EvidenceCard
            variant="clipping"
            pin="black"
            rotate={-1.1}
            className="prior-record"
            detail={detailFromPriorRecord(earlierRoles)}
          >
            <p className="clipping-kicker">Prior record · 2017–2018</p>
            {earlierRoles.map((role) => (
              <div key={role.id} className="prior-row">
                {role.logo ? (
                  <EvidenceImage src={role.logo} alt="" variant="logo" pin={false} className="prior-logo-image" />
                ) : null}
                <div>
                  <strong>{role.title}</strong>
                  <p>
                    {role.link ? (
                      <a href={role.link} target="_blank" rel="noreferrer">
                        {role.company}
                      </a>
                    ) : (
                      role.company
                    )}
                  </p>
                  <p className="timeline-dates">{role.duration}</p>
                </div>
              </div>
            ))}
          </EvidenceCard>
        </li>
      </ol>
    </div>
  </div>
);

export default ExperienceSection;
